export const COPY = {
  description: 'Do you have an idea that could improve your community?',
  createIdeaAction: 'Submit an Idea',
  modal: {
    title: 'Share ideas with your community',
    description: 'Once you join Polco, you can submit your own ideas.',
    secondaryButtonLabel: 'Account Setup',
  },
};
